import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import services from '../../services';
import { useDispatch } from 'react-redux';
import { toggleDate, toggleTable } from '../../Redux/slice';
import { getAllDateTableTask } from '../../Redux/GetSlice';

const ArchivedHeader = () => {
    const [activeButton, setActiveButton] = useState('board');
    const [boardName, setBoardName] = useState([]);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        getAllBoard();
    }, []);

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const mapData = data?.map(({ boardName, id }) => ({ label: boardName, value: id }));
            setBoardName(mapData);
            const savedBoardId = localStorage.getItem('boardId');
            if (savedBoardId && mapData.length > 0) {
                const board = mapData.find((b) => b.value === savedBoardId);
                setSelectedBoard(board || mapData[0]);
            } else if (mapData.length > 0) {
                setSelectedBoard(mapData[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleClick = (button) => {
        setActiveButton(button);
        const boardId = selectedBoard?.value;

        if (button === 'board') {
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            navigate('/app');
        } else if (button === 'date') {
            if (boardId) {
                dispatch(getAllDateTableTask({ data: { boardId } }));
            }
            dispatch(toggleDate(true));
            dispatch(toggleTable(false));
            navigate('/app');
        } else if (button === 'table') {
            dispatch(toggleTable(true));
            dispatch(toggleDate(false));
            navigate('/app');
        }
    };

    const handleSelectedBoard = (e) => {
        setSelectedBoard(e);
        localStorage.setItem('boardId', e?.value);
        window.location.reload();
    };

    const getButtonClass = (button) =>
        `p-[7px] ${activeButton === button ? 'bg-[#20212414]' : 'bg-white'
        } mr-[5px] items-center flex cursor-pointer text-black gap-[4px] rounded-[5px]`;

    return (
        <div className="header-app flex items-center p-2 border-b">
            <div className="flex-1">
            <button
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 font-semibold text-blue-500 bg-white border border-blue-500 rounded-md hover:bg-blue-50"
                >
                    Back
                </button>
            </div>
            <div className="flex-1 flex justify-center">
                {/* <div className="flex gap-2">
                    <div onClick={() => handleClick('board')} className={getButtonClass('board')}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="20"
                            fill="currentColor"
                            className="bi bi-filter-right rotate-[0deg]"
                            viewBox="0 0 16 16"
                        >
                            <path d="M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5m0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5" />
                        </svg>
                        <span className="text-[11.2px] custom-tab-label">Board</span>
                    </div>
                    <div onClick={() => handleClick('table')} className={getButtonClass('table')}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="20"
                            fill="currentColor"
                            className="bi bi-calendar2-range"
                            viewBox="0 0 16 16"
                        >
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                            <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM9 8a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1m-8 2h4a1 1 0 1 1 0 2H1z" />
                        </svg>
                        <button className="text-[11.2px] custom-tab-label">Table</button>
                    </div>
                    <div onClick={() => handleClick('date')} className={getButtonClass('date')}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="20"
                            fill="currentColor"
                            className="bi bi-calendar3-event"
                            viewBox="0 0 16 16"
                        >
                            <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                            <path d="M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                        </svg>
                        <button className="text-[11.2px] custom-tab-label">Date</button>
                    </div>
                </div> */}
            </div>
            {/* <div className="flex-1 flex justify-end">
                <div
                    style={{
                        width: '150px',
                        border: '1px solid lightgrey',
                        borderRadius: '4px'
                    }}
                >
                    <Select
                        className="cursor-pointer"
                        style={{ width: '150px' }}
                        options={boardName}
                        onChange={handleSelectedBoard}
                        value={selectedBoard}
                    />
                </div>
            </div> */}
        </div>
    );
};

export default ArchivedHeader; 